<div  class="container" style="width: 400px;">
    <div class="my-2" *ngIf="!dataLoads">
        <div class="d-flex justify-content-between align-items-center p-2">
            <h2 style="font-family: 'poppins';margin:0px !important;line-height: 15px;font-weight: 600;font-size: 16px;">{{"Select"}}</h2>
            <mat-icon (click)="closeInst()" svgIcon="cancel_x" style="cursor: pointer;width: 13px;color: #8A98AB !important;"></mat-icon>
        </div>
        <div class="row">
            <div class="col-md-12 col-md-12 col-12">
                <ul class="list-group">
                    <li class="list-group-item d-flex align-items-center"
                        style="gap: 10px; cursor: pointer;">
                        <input type="checkbox" style="cursor: pointer;"
                            [(ngModel)]="masterSelected"
                            name="list_name" value="m1"
                            (change)="checkUncheckAll()" />
                        <strong
                            (click)="masterSelected=!masterSelected; checkUncheckAll()">Select/Unselect
                            All</strong>
                    </li>
                </ul>
                <ul class="list-group du-server-list-group">
                    <li class="list-group-item d-flex align-items-center"
                        *ngFor="let item of checklist"
                        style="gap: 10px; cursor: pointer;">
                        <input type="checkbox" style="cursor: pointer;"
                            [(ngModel)]="item['isExportSelected']"
                            name="list_name" [value]="item.field"
                            (change)="isAllSelected()" />
                        <span
                            (click)="item['isExportSelected']=!item['isExportSelected']; isAllSelected()">{{item.headerName}}</span>
                    </li>
                </ul>
            </div>
            <div style="text-align: right;margin: 10px 0;">
                <button 
                    [disabled]="this.checkedList?.length==0"
                    type="button" 
                    style="font-family: 'Poppins';font-size: 12px;width: 75px;" 
                    class="btn btn-primary btncreate" 
                    (click)="this.rowDataCount>=20000 ? waringFunc() : selectedExport()"
                >Export</button>
            </div>
        </div>
    </div>
    
    <div *ngIf="dataLoads" class="my-2" style="position: relative;">
        <div *ngIf="warnings">
            <div class="d-flex justify-content-end align-items-center p-2">
                <mat-icon (click)="closeInst()" svgIcon="cancel_x" style="cursor: pointer;width: 13px;color: #8A98AB !important;"></mat-icon>
            </div>
            
            <div class="my-2 text-center">
                <div class="circle-loader load-complete">
                    <div class="info-symbol" style="font-size: 36px;font-weight: 600;display: block;">i</div>
                </div>
            </div>
            
            <div class="mb-4 mt-2 text-center">
                <span style="text-align: center;font-weight: 500; font-size: 13px;">
                    You are exporting a large dataset. Are you sure you want to proceed?
                </span>
            </div>
            <div class="d-flex justify-content-center align-items-center" style="padding: 15px;">
                <div style="margin: 5px;">
                    <button type="button" style="font-family: 'Poppins';font-size: 12px;width: 75px;" class="btn btn-outline-primary" (click)="this.warnings = false;this.dataLoads = false;">Cancel</button>
                </div>
                <div style="margin: 5px;">
                    <button type="button" style="font-family: 'Poppins';font-size: 12px;width: 75px;" class="btn btn-primary btncreate" (click)="selectedExport()">OK</button>
                </div>
            </div>
            
        </div>
        
        <div *ngIf="!warnings">
            <div class="d-flex justify-content-end align-items-center p-2">
                <mat-icon (click)="closeInst()" svgIcon="cancel_x" style="cursor: pointer;width: 13px;color: #8A98AB !important;"></mat-icon>
            </div>
        
            <div style="text-align: center;align-content: center;" class="du-server-list-group">
                <div *ngIf="this.loaderApi">
                    <div *ngIf="LoadingText">
                        <div class="circle-loader" >
                            <div class="checkmark draw"></div>
                        </div>
                    </div>
                    
                    <div *ngIf="!LoadingText">
                        <div class="circle-loader">
                            <div class="info-symbol" style="font-size: 36px;font-weight: 600;">i</div>
                        </div>
                    </div>
    
                    <div >
                        <h2 class="successHeader" style="font-family: 'Poppins';font-size: 18px;font-weight: 600;">{{ LoadingText }}</h2>
                        <p class="followStatusParag" style="font-family: 'Poppins';font-size: 12px;">
                            {{ api_status }}
                        </p>
                    </div>
                </div>
        
                <div *ngIf="!this.loaderApi">
                    <div style="text-align: center;margin-bottom: 10px;">
                        <svg style="width: 50px;height: 50px;color: #d10410;border: 2px solid #d10410;border-radius: 50px;padding: 7px;"
                            xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                            fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </div>
        
                    <div>
                        <h2 class="successHeader" style="font-family: 'Poppins';font-size: 18px;font-weight: 600;">Failed!</h2>
                        <p class="followStatusParag" style="font-family: 'Poppins';font-size: 14px;">{{ failureMessage }}</p>
                    </div>
                </div>
                <div style="margin: 20px;" *ngIf="visibleData">
                    <button type="button" style="font-family: 'Poppins';font-size: 12px;" class="btn btn-primary btncreate" (click)="gotItBack()">Got it</button>
                </div>
            </div>
        </div>
    
    </div>
</div>
